// Our main CSS
import '../css/app.css'

/**
 * Vue is ready for you, if you need it.
 */

import { ModuleManager } from './moduleManager'

// Create and configure module manager
const moduleManager = new ModuleManager()// Register all modules with their selectors
moduleManager
  .register('.js-hero', 'hero')
  .register('.js-parallax', 'parallax')
  .register('.js-cta', 'cta')
  .register('.js-form', 'form')
  .register('.js-info', 'info')
  .register('.js-mobile-menu-toggle', 'mobile-menu')

// Initialize modules
moduleManager.init()